import { render, staticRenderFns } from "./PwdResetForm.vue?vue&type=template&id=9af7d0e2&scoped=true&"
import script from "./PwdResetForm.vue?vue&type=script&lang=js&"
export * from "./PwdResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PwdResetForm.vue?vue&type=style&index=0&id=9af7d0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af7d0e2",
  null
  
)

export default component.exports